import { useGetUsers } from './use-get-users';

export const useUsersTotalPage = () => {
  const usersQuery = useGetUsers();

  return usersQuery?.data?.pagination.totalPages ?? 0;
};
